import React from 'react'
import Box, { BoxProps } from '../kit/box'
import { Column, ColumnProps, Row, RowProps } from '../kit/grid'
import Text, { TextProps } from '../kit/text'

/* -----------------------------------------------------------------------------
 * RowWrapper
 * -------------------------------------------------------------------------- */

const RowWrapper = ({
  alignItems = 'center',
  borderBottomWidth = '1px',
  borderColor = 'shade03',
  borderRadius = 'none',
  justifyContent = 'space-between',
  p = '12',
  children,
  ...otherProps
}: RowProps) => (
  <Row
    alignItems={alignItems}
    borderBottomWidth={borderBottomWidth}
    borderColor={borderColor}
    borderRadius={borderRadius}
    justifyContent={justifyContent}
    p={p}
    {...otherProps}
  >
    {children}
  </Row>
)

/* -----------------------------------------------------------------------------
 * ColumnWrapper
 * -------------------------------------------------------------------------- */

const ColumnWrapper = ({
  borderBottomWidth = '1px',
  borderColor = 'shade02',
  borderRadius = 'none',
  m = -1 as any,
  p = '12',
  children,
  ...otherProps
}: ColumnProps) => (
  <Column
    borderBottomWidth={borderBottomWidth}
    borderColor={borderColor}
    borderRadius={borderRadius}
    m={m}
    p={p}
    {...otherProps}
  >
    {children}
  </Column>
)

/* -----------------------------------------------------------------------------
 * HorizontalRule
 * -------------------------------------------------------------------------- */

const HorizontalRule = ({
  width = '100%',
  height = '2px',
  backgroundColor = 'blueShade',
  ...otherProps
}: BoxProps) => (
  <Box width={width} height={height} backgroundColor={backgroundColor} />
)

/* -----------------------------------------------------------------------------
 * LabelText
 * -------------------------------------------------------------------------- */

const LabelText = ({
  textColor = 'newMutedPurple',
  font = 'text.12.bold',
  children,
  ...otherProps
}: TextProps) => (
  <Text textColor={textColor} font={font} {...otherProps}>
    {children}
  </Text>
)

/* -----------------------------------------------------------------------------
 * ValueText
 * -------------------------------------------------------------------------- */

const ValueText = ({
  textColor = 'newPurple',
  font = 'display.14.bold',
  children,
  ...otherProps
}: TextProps) => (
  <Text textColor={textColor} font={font} {...otherProps}>
    {children}
  </Text>
)

export { RowWrapper, ColumnWrapper, HorizontalRule, LabelText, ValueText }
